import { ESHOP_URL } from '@common/config'

export function useUrls() {
  return {
    eshopUrl: ESHOP_URL,
  }
}
